<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useGlobalSearch } from '@/composables/useGlobalSearch'

defineOptions({ name: 'GlobalSearchTrigger' })

const { t } = useI18n()
const search = useGlobalSearch()
</script>

<template>
  <button
    class="search-trigger"
    type="button"
    :aria-label="t('globalSearch.openSearchShortcut')"
    @click="search.open()"
  >
    <v-icon icon="mdi-magnify" size="20" />
    <span class="search-placeholder">{{ t('globalSearch.triggerText') }}</span>
    <kbd class="search-shortcut">
      <span>Ctrl</span>K
    </kbd>
  </button>
</template>

<style lang="scss" scoped>
.search-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(120, 163, 255, 0.12);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(120, 163, 255, 0.25);
    color: rgba(255, 255, 255, 0.85);
  }

  .search-placeholder {
    min-width: 70px;
    text-align: left;
  }

  .search-shortcut {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 3px 6px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    font-size: 0.7rem;
    font-family: inherit;
    color: rgba(255, 255, 255, 0.5);
  }
}

/* Light Theme */
.v-theme--lightTheme {
  .search-trigger {
    background: rgba(0, 0, 0, 0.04);
    border-color: rgba(28, 110, 227, 0.15);
    color: rgba(15, 23, 42, 0.6);

    &:hover {
      background: rgba(0, 0, 0, 0.08);
      border-color: rgba(28, 110, 227, 0.25);
      color: rgba(15, 23, 42, 0.85);
    }

    .search-shortcut {
      background: rgba(0, 0, 0, 0.04);
      border-color: rgba(0, 0, 0, 0.1);
      color: rgba(15, 23, 42, 0.5);
    }
  }
}

/* Responsive - icon only on smaller screens */
@media (max-width: 900px) {
  .search-trigger {
    padding: 0 10px;
    min-width: 40px;

    .search-placeholder,
    .search-shortcut {
      display: none;
    }
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .search-trigger {
    transition: none;
  }
}
</style>
